export const vueRoutes = Object.freeze({
  app: { name: 'app' },
  auth: { name: 'auth' },
  login: { name: 'login' },
  logs: {
    name: 'logs',
    permissions: [
      {
        resource: 'log',
        action: 'read',
        children: [
          {
            resource: 'log',
            action: 'read_foreign',
          },
        ],
      },
    ],
  },
  logsList: { name: 'logs-list' },
  logDetails: { name: 'log-details' },
  admins: {
    name: 'admins',
    permissions: [
      {
        action: 'read_foreign',
        resource: 'users',
      },
    ],
  },
  adminsList: { name: 'admins-list' },
  adminDetails: { name: 'admins-details' },
  adminsManagerAdd: { name: 'admins-manager-add' },
  users: {
    name: 'users',
    permissions: [
      {
        action: 'read_foreign',
        resource: 'users',
        children: [
          {
            action: 'read',
            resource: 'user',
          },
          {
            action: 'read_foreign',
            resource: 'user',
          },
          {
            action: 'read',
            resource: 'nft_permissions',
          },
        ],
      },
    ],
  },
  usersList: { name: 'users-list' },
  user: {
    name: 'user',
    permissions: [
      {
        action: 'read_foreign',
        resource: 'user',
        children: [
          {
            action: 'read',
            resource: 'user',
          },
          {
            action: 'update',
            resource: 'user',
          },
          {
            action: 'update_foreign',
            resource: 'user',
          },
          {
            action: 'read_foreign',
            resource: 'user',
          },
          {
            action: 'read_foreign',
            resource: 'address',
          },
          {
            action: 'read',
            resource: 'address',
          },
          {
            action: 'update_foreign',
            resource: 'address',
          },
        ],
      },
    ],
  },
  userDetails: { name: 'user-details' },
  userVerifications: { name: 'user-verifications' },
  userTransactions: { name: 'user-transactions' },
  userVerificationComments: { name: 'user-verification-comments' },
  userCDDs: { name: 'user-cdds' },
  userBDDs: { name: 'user-bdds' },

  announcements: {
    name: 'announcements',
    permissions: [
      {
        action: 'read_foreign',
        resource: 'announcement',
        children: [
          {
            action: 'read_foreign',
            resource: 'announcement',
          },
          {
            action: 'create',
            resource: 'announcement',
          },
          {
            action: 'delete',
            resource: 'announcement',
          },
          {
            action: 'update',
            resource: 'announcement',
          },
        ],
      },
    ],
  },
  announcementList: { name: 'announcement-list' },
  announcementDetails: { name: 'announcement-details' },
  supportedNetworks: {
    name: 'supported-networks',
    permissions: [
      {
        action: 'read_foreign',
        resource: 'supportedNetwork',
        children: [
          {
            action: 'read_foreign',
            resource: 'supportedNetwork',
          },
          {
            action: 'update',
            resource: 'supportedNetwork',
          },
          {
            action: 'create',
            resource: 'supportedNetwork',
          },
          {
            action: 'delete',
            resource: 'supportedNetwork',
          },
        ],
      },
    ],
  },
  supportedNetworksList: { name: 'supported-networks-list' },

  verifications: {
    name: 'verifications',
    permissions: [
      {
        action: 'read_foreign',
        resource: 'verification',
        children: [
          {
            action: 'update',
            resource: 'verification',
          },
          {
            action: 'update_foreign',
            resource: 'verification',
          },
          {
            action: 'read_foreign',
            resource: 'verification',
          },
          {
            action: 'read_foreign',
            resource: 'limited_risk_report',
          },
        ],
      },
    ],
  },
  verificationsList: { name: 'verifications-list' },
  verificationDetails: { name: 'verification-details' },
  verificationDetailsExport: { name: 'verification-details-export' },
  quickbuy: {
    name: 'quickbuy',
    permissions: [
      {
        action: 'read_foreign',
        resource: 'quickbuy_voucher',
        children: [
          {
            action: 'update_foreign',
            resource: 'quickbuy_voucher',
          },
        ],
      },
    ],
  },
  quickbuyVerifications: { name: 'quickbuy-verifications' },
  quickbuyVerificationDetails: { name: 'quickbuy-verification-details' },
  roles: {
    name: 'roles',
    permissions: [
      {
        resource: 'role',
        action: 'read_foreign',
        children: [
          {
            resource: 'role',
            action: 'read_foreign',
          },
          {
            resource: 'role',
            action: 'create',
          },
          {
            resource: 'role',
            action: 'update',
          },
          {
            resource: 'role',
            action: 'delete',
          },
          {
            resource: 'role',
            action: 'delete_foreign',
          },
        ],
      },
    ],
  },
  rolesList: { name: 'roles-list' },
  roleDetails: { name: 'role-details' },
  roleCreate: { name: 'role-create' },
  adminActions: {
    name: 'admin-actions',
    permissions: [
      {
        action: 'read_foreign',
        resource: 'kyc_exception',
        children: [
          {
            action: 'read',
            resource: 'kyc_exception',
          },
          {
            action: 'create',
            resource: 'kyc_exception',
          },
          {
            action: 'delete_foreign',
            resource: 'kyc_exception',
          },
          {
            action: 'delete',
            resource: 'kyc_exception',
          },
        ],
      },
    ],
  },

  businesses: {
    name: 'businesses',
    permissions: [
      {
        resource: 'kyb_session',
        action: 'read_foreign',
        children: [
          {
            resource: 'kyb_session',
            action: 'read',
          },
          {
            resource: 'kyb_session',
            action: 'read_foreign',
          },
        ],
      },
    ],
  },
  businessList: { name: 'business-list' },
  businessDetails: { name: 'business-details' },
  userBusinessList: { name: 'user-business-list' },

  dashboardPage: { name: 'dashboard-page' },
  dashboard: {
    name: 'dashboard',
    permissions: [
      {
        resource: 'users_common_stat',
        action: 'read_foreign',
        children: [],
      },
    ],
  },

  widgetAccessKeys: {
    name: 'widgetAccessKeys',
    permissions: [
      {
        action: 'widget_access',
        resource: 'read',
        children: [
          {
            action: 'widget_access',
            resource: 'read',
          },
          {
            action: 'widget_access',
            resource: 'create',
          },
          {
            action: 'widget_access',
            resource: 'update',
          },
          {
            action: 'widget_access',
            resource: 'delete',
          },
        ],
      },
    ],
  },
  widgetAccessKeyList: { name: 'widgetAccessKeyList' },
  featureFlags: {
    name: 'feature-flags',
    permissions: [
      {
        action: 'feature_access',
        resource: 'read',
        children: [
          {
            action: 'feature_access',
            resource: 'read',
          },
          {
            action: 'feature_access',
            resource: 'create',
          },
          {
            action: 'feature_access',
            resource: 'update',
          },
          {
            action: 'feature_access',
            resource: 'delete',
          },
        ],
      },
    ],
  },
  permissionTransactions: {
    name: 'permission-transactions',
    permissions: [
      {
        action: 'read',
        resource: 'user',
      },
    ],
  },
})
